import type { MouseEventHandler, ReactNode } from 'react';

import { IconButton, Tooltip } from '@mui/material';
import type { Sx } from '@/shared/types/uiTypes';

import { Z_INDEX } from '@/config/z-index';
import { normalizeSx } from '@/shared/lib/normalizeSx';

export type WidgetButtonProps = {
  title: string;
  icon: ReactNode;
  onClick: MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  id?: string;
  sx?: Sx;
};

const tooltipSlotProps = { popper: { sx: { zIndex: Z_INDEX.menu } } } as const;

const buttonBaseSx = {
  width: 30,
  height: 48,
  p: 0,
  minWidth: 30,
  borderRadius: 0,
  backgroundColor: 'gx.tileLight'
} as const;

const WidgetButton = ({ title, icon, onClick, disabled, id, sx }: WidgetButtonProps) => (
  <Tooltip
    slotProps={tooltipSlotProps}
    title={title}
  >
    <span style={{ display: 'inline-flex' }}>
      <IconButton
        aria-label={title}
        disabled={disabled}
        id={id}
        sx={[buttonBaseSx, ...normalizeSx(sx)]}
        onClick={onClick}
      >
        {icon}
      </IconButton>
    </span>
  </Tooltip>
);

export default WidgetButton;
